import {IAction} from 'redux/interface';
import {
  ICmFilter, ICmService, ICmServiceResponse
} from './interfaces';
import {InferActionsTypes} from 'redux/helpers';
import {CmFilterModel} from '../../components/cm-filters/CmFilterModels';

export const CM_FILTER_LOADED = 'CM_FILTER_LOADED';
export const cmFiltersLoadedAction = (filters: ICmFilter[]): IAction<ICmFilter[]> => ({
  type: CM_FILTER_LOADED,
  payload: filters
});
export const COUNTY_FILTER_LOADED = 'COUNTY_FILTER_LOADED';
export const cmCountyFiltersLoadedAction = (countyFilter: ICmFilter): IAction<ICmFilter> => ({
  type: COUNTY_FILTER_LOADED,
  payload: countyFilter
});
export const COUNTY_FILTER_CLEARED = 'COUNTY_FILTER_CLEARED';
export const cmCountyFiltersClearedAction = (): IAction<null> => ({
  type: COUNTY_FILTER_CLEARED,
  payload: null
});
export const SERVICES_LOADED = 'SERVICES_LOADED';
export const cmServicesLoadedAction = (service: ICmServiceResponse): IAction<ICmServiceResponse> => ({
  type: SERVICES_LOADED,
  payload: service
});
export const SERVICE_LOADED = 'SERVICE_LOADED';
export const cmServiceLoadedAction = (service: ICmService): IAction<ICmService> => ({
  type: SERVICE_LOADED,
  payload: service
});
export const SERVICES_ORG_LOADED = 'SERVICES_ORG_LOADED';
export const cmServicesOrgLoadedAction = (services: ICmServiceResponse): IAction<ICmServiceResponse> => ({
  type: SERVICES_ORG_LOADED,
  payload: services
});
export const SELECTED_FILTER_LOADED = 'SELECTED_FILTER_LOADED';
export const selectedCmFiltersLoadedAction = (filters: Record<string, CmFilterModel>): IAction<Record<string, CmFilterModel>> => ({
  type: SELECTED_FILTER_LOADED,
  payload: filters
});
export const STRING_FILTER_LOADED = 'STRING_FILTER_LOADED';
export const stringCmFiltersLoadedAction = (filter: ICmFilter): IAction<ICmFilter> => ({
  type: STRING_FILTER_LOADED,
  payload: filter
});
export const FAVORITE_FILTER_LOADED = 'FAVORITE_FILTER_LOADED';
export const favoriteCmFiltersLoadedAction = (filter: ICmFilter): IAction<ICmFilter> => ({
  type: FAVORITE_FILTER_LOADED,
  payload: filter
});

export const SERVICE_CHECK_FAVORITE = 'SERVICE_CHECK_FAVORITE';
export const checkFavoriteAction = (srvId: number): IAction<number> => ({
  type: SERVICE_CHECK_FAVORITE,
  payload: srvId
});

export const SERVICE_UNCHECK_FAVORITE = 'SERVICE_UNCHECK_FAVORITE';
export const uncheckFavoriteAction = (srvId: number): IAction<number> => ({
  type: SERVICE_UNCHECK_FAVORITE,
  payload: srvId
});

export const SERVICE_CHECK_REFERRALS = 'SERVICE_CHECK_REFERRALS';
export const checkReferralsAction = (srvId: number): IAction<number> => ({
  type: SERVICE_CHECK_REFERRALS,
  payload: srvId
});

export const SERVICE_UNCHECK_REFERRALS = 'SERVICE_UNCHECK_REFERRALS';
export const uncheckReferralsAction = (srvId: number[]): IAction<number[]> => ({
  type: SERVICE_UNCHECK_REFERRALS,
  payload: srvId
});

export const REFERRALS_LOADED = 'REFERRALS_LOADED';
export const referralsLoadedAction = (referrals: ICmService[]): IAction<ICmService[]> => ({
  type: REFERRALS_LOADED,
  payload: referrals
});

export const SET_SEND_REFERRALS_STATUS = 'SET_SEND_REFERRALS_STATUS';
export const setSendReferralsStatus = (status: boolean): IAction<boolean> => ({
  type: SET_SEND_REFERRALS_STATUS,
  payload: status
});

const serviceActions = {
  cmFiltersLoadedAction,
  cmCountyFiltersLoadedAction,
  cmServiceLoadedAction,
  selectedCmFiltersLoadedAction,
  cmCountyFiltersClearedAction,
  checkFavoriteAction,
  uncheckFavoriteAction,
  checkReferralsAction,
  uncheckReferralsAction,
  referralsLoadedAction,
  setSendReferralsStatus,
  cmServicesOrgLoadedAction
};

export type CmServiceActionsType = InferActionsTypes<typeof serviceActions>
